import React from 'react';

/**
 * Encabezado de cada paso de la reserva.
 *
 * Antes cada sección tenía su propio <h2> con el número escrito a mano
 * ("Paso 1: Elige tu Servicio", "Paso 2 o 3: Elige el Lugar" — la numeración
 * cambiaba según qué pasos aplicaran, y se calculaba en el JSX). Acá el número
 * llega como prop desde un solo lugar.
 */
export default function PasoSeccion({ numero, titulo, descripcion }) {
  // `mb-4` en teléfono y `mb-6` de ahí para arriba. Los 24px fijos venían del
  // diseño de escritorio: medido en la página, entre el título del paso y la
  // tarjeta del calendario quedaban 50px de aire, y en una pantalla de 844px
  // cada hueco así es contenido que no entra.
  return (
    <header className="mb-4 sm:mb-6">
      <div className="flex items-center gap-3">
        <span
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground"
          aria-hidden="true"
        >
          {numero}
        </span>
        <h2 className="text-xl font-bold tracking-tight text-neutral-900 sm:text-2xl">
          <span className="sr-only">Paso {numero}: </span>
          {titulo}
        </h2>
      </div>
      {descripcion && (
        <p className="mt-2 text-sm leading-relaxed text-neutral-600 sm:ml-11">{descripcion}</p>
      )}
    </header>
  );
}
